module.exports = __webpack_public_path__ + "img/6001005000.4fb33b5.webp";